/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoneyInPayshopInitInput
 */
export interface MoneyInPayshopInitInput {
    /**
     * Your site returns the URL, called to terminate the operation and on which the callback will be sent, with data in POST parameters.
     * This URL must contain a unique ID so you know which operation is related to the return.
     * @type {string}
     * @memberof MoneyInPayshopInitInput
     */
    returnUrl: string;
    /**
     * Unique ID of the call, generated by your server. This ID can be used as a search field when looking for operation details
     * @type {string}
     * @memberof MoneyInPayshopInitInput
     */
    reference?: string;
    /**
     * Payment Account ID to Credit
     * @type {string}
     * @memberof MoneyInPayshopInitInput
     */
    accountId: string;
    /**
     * Amount to Debit
     * Amounts are given as integer numbers in cents
     * @type {number}
     * @memberof MoneyInPayshopInitInput
     */
    totalAmount?: number;
    /**
     * Your Fee
     * Amounts are given as integer numbers in cents
     * @type {number}
     * @memberof MoneyInPayshopInitInput
     */
    commissionAmount?: number;
    /**
     * Comment Regarding the Transaction
     * @type {string}
     * @memberof MoneyInPayshopInitInput
     */
    comment?: string;
    /**
     * If true:
     * 1. [amountCom] will be ignored and will be replaced with Lemonway's fee
     * 2. You will not receive any fee
     * @type {boolean}
     * @memberof MoneyInPayshopInitInput
     */
    autoCommission?: boolean;
}

/**
 * Check if a given object implements the MoneyInPayshopInitInput interface.
 */
export function instanceOfMoneyInPayshopInitInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "returnUrl" in value;
    isInstance = isInstance && "accountId" in value;

    return isInstance;
}

export function MoneyInPayshopInitInputFromJSON(json: any): MoneyInPayshopInitInput {
    return MoneyInPayshopInitInputFromJSONTyped(json, false);
}

export function MoneyInPayshopInitInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyInPayshopInitInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'returnUrl': json['returnUrl'],
        'reference': !exists(json, 'reference') ? undefined : json['reference'],
        'accountId': json['accountId'],
        'totalAmount': !exists(json, 'totalAmount') ? undefined : json['totalAmount'],
        'commissionAmount': !exists(json, 'commissionAmount') ? undefined : json['commissionAmount'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'autoCommission': !exists(json, 'autoCommission') ? undefined : json['autoCommission'],
    };
}

export function MoneyInPayshopInitInputToJSON(value?: MoneyInPayshopInitInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'returnUrl': value.returnUrl,
        'reference': value.reference,
        'accountId': value.accountId,
        'totalAmount': value.totalAmount,
        'commissionAmount': value.commissionAmount,
        'comment': value.comment,
        'autoCommission': value.autoCommission,
    };
}

